<template>
  <div>
    <div
      class="announcement-card"
      v-for="(item, index) in allChapterStudioAnnouncements"
      :key="index"
    >
      <div v-if="!item.isPublished" class="announcement-card__header">
        {{ manageChapterStudioConstant.UNSCHEDULED_DRAFT }}
      </div>
      <h3 class="announcement-card__title">{{ item.title }}</h3>

      <div class="announcement-card__content">
        <div class="announcement-card__info-left">
          <p>
            <span class="announcement-card__info-left__left_title">{{ manageChapterStudioConstant.DISPLAY_RANGE }}</span>
            <span class="announcement-card__info-left__left_details">{{ formatDate(item.displayStartDate) }} -
            {{ formatDate(item.displayEndDate) }}</span>
          </p>
          <p v-if="shouldShowEffectiveRange(item)">
            <span class="announcement-card__info-left__left_title">{{ manageChapterStudioConstant.EFFECTIVE_RANGE }}</span>
            <span class="announcement-card__info-left__left_details">{{ formatDate(item.effectiveStartDate) }} -
            {{ formatDate(item.effectiveEndDate) }}</span>
          </p>
          <p>
            <span class="announcement-card__info-left__left_title">{{ manageChapterStudioConstant.ANNOUNCEMENT_TYPE }}</span>
            <span class="announcement-card__info-left__left_details">{{ item.recordTypeName }}</span>
          </p>
          <p>
            <span class="announcement-card__info-left__left_title">{{ manageChapterStudioConstant.DEPT_REGION }}</span>
            <span class="announcement-card__info-left__left_details">{{ limitedSponsorRegions(item) }}</span>
          </p>
          <p>
            <span class="announcement-card__info-left__left_title">{{ manageChapterStudioConstant.VISIBLE_TO }}</span>
            <span class="announcement-card__info-left__left_details">{{ getVisibleToDisplay(item) }}</span>
          </p>
        </div>

        <div class="announcement-card__info-right">
          <div class="short-description">
            <span class="short-description__title">{{
              manageChapterStudioConstant.SHORT_DESCRIPTION
            }}</span>
            <span class="short-description__content">{{
              item.shortDescription
            }}</span>
          </div>
        </div>

        <div class="announcement-card__actions" v-if="item.canEditAnnouncement">
          <div class="announcement-card__button-container">
            <button
              class="announcement-card__button announcement-card__button--edit"
              @click="editAnnouncement(item.id)"
              >
              {{ manageChapterStudioConstant.EDIT }}
            </button>
          </div>

          <div class="announcement-card__button-container">
            <button
              class="announcement-card__button announcement-card__button--delete"
              @click="deleteAnnouncement(item)"
            >
              {{ manageChapterStudioConstant.DELETE }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="isOpenDeleteDialog" lazy absolute content-class="post-actions" persistent>
            <v-card>
                <h6>Delete Announcement
                    <v-btn icon data-qe-id="dialog_close_btn" @click="cancelDeleteDialog()">
                        <v-icon size="20">close</v-icon>
                    </v-btn>
                </h6>

                <p>{{ manageChapterStudioConstant.DELETE_CONFIRMATION_MESSAGE }}</p>
                <v-flex text-xs-right>
                    <v-btn class="primary_btn transparent small" data-qe-id="dialog_cancel_btn"
                        @click="cancelDeleteDialog()">
                        {{appCommonConstants.CANCEL}}
                    </v-btn>
                    <v-btn class="primary_btn small" data-qe-id="dialog_confirm_btn" @click="confirmDelete()">
                        {{appCommonConstants.CONFIRM}}
                    </v-btn>
                </v-flex>
            </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { manageChapterStudioConstant, createChapterStudioConstant } from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";
import { formatDate } from "../../common/utils/dateTime.js";
import { storeAction } from "@/store/storeActions.constant";
import { mapActions } from "vuex";
import { routerNames, appCommonConstants } from "@/components/appCommon.constants";

export default {
  name: "CardComponent",
  data() {
    return {
      manageChapterStudioConstant,
      createChapterStudioConstant,
      appCommonConstants,
      formatDate,
      isOpenDeleteDialog: false,
      announcement: null,
    };
  },
  props: {
    allChapterStudioAnnouncements: {
      type: Array,
      required: true,
    },
  },
  computed: {},
  methods: {
    ...mapActions({
        saveChapterStudioAnnouncement: `manageChapterStudio/${storeAction.saveChapterStudioAnnouncement}`,
        getAllChapterStudioAnnouncements: `manageChapterStudio/${storeAction.getAllChapterStudioAnnouncements}`,
    }),
    ...mapActions('snackbar', [
      `${storeAction.setToastMessage}`,
      `${storeAction.hideSnackbar}`,
    ]),
    limitedSponsorRegions(item) {
      const spList =
        item.sponsorRegionsList || item.sponsorDepartmentList || [];
      return spList.slice(0, 4).join(", ");
    },
    deleteAnnouncement(item) {
      this.isOpenDeleteDialog = true;
      this.announcement = item;
    },
    cancelDeleteDialog() {
      this.isOpenDeleteDialog = false;
    },
    editAnnouncement(announcementId) {
        this.$router.push(`/${routerNames.CREATE_ANNOUNCEMENT}/${announcementId}`);
    },
    confirmDelete() {
        this.announcement.isActive = false;
        this.saveChapterStudioAnnouncement(this.announcement)
        .then(() => {
          this.isOpenDeleteDialog = false;
          this.setToastMessage({
            color: 'success',
            message: this.manageChapterStudioConstant.ITEM_DELETED_SUCCESS,
          });
          this.getAllChapterStudioAnnouncements();
        })
        .catch(() => {
          this.isOpenDeleteDialog = false;
          this.setToastMessage({
            color: 'error',
            message: this.manageChapterStudioConstant.ITEM_FAILED_DELETE,
          });
        });
    },
    getVisibleToDisplay(announcement) {
      return announcement && announcement.visibleToObject && announcement.visibleToObject.name
          ? announcement.visibleToObject.name
          : '';
    },
    shouldShowEffectiveRange(item) {
      return (item.recordTypeName === this.createChapterStudioConstant.RECORD_TYPE.IMAGE && (item.effectiveStartDate || '').trim() && (item.effectiveEndDate || '').trim());
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";
@import "../../common/styles/_colors.scss";


.announcement-card {
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #ddd;
  margin-bottom: 12px;
  border-radius: 8px;
  max-width: 100%;

  p {
    margin-bottom: -4px;
  }
  &__title {
    font-family: 'Helvetica', sans-serif;
    display: block;
    max-width: 80%;
    text-align: left;
    font-weight: 700;
    font-size: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 10px 5px 8px;

    @include breakpointMin(sm) {
        margin-left: 6px;
        padding: 10px 0 10px 8px;
    }
  }

  &__header {
    background-color: $mild-grey;
    color: white;
    padding: 8px 0 6px 14px;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }

  &__content {
    display: flex;
    flex: 1;
    position: relative;
    flex-direction: column;

    @include breakpointMin(sm) {
      flex-direction: row;
    }
    .announcement-card__info-left {
      flex: 1;
      padding: 0 9px 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 80%;

      @include breakpointMin(sm) {
        max-width: 45%;
        padding: 0 9px 18px 18px;
      }

      &__left_title {
        font-weight: 700;
        font-size: 12px;
      }

      &__left_details {
        font-weight: 400;
        font-size: 12px;
      }
    }

    .announcement-card__info-right {
      display: flex;
      flex-direction: column;
      font-family: Arial, sans-serif;
      padding: 8px 0 14px 10px;
      max-width: 70%;

      @include breakpointMin(sm) {
        max-width: 30%;
        padding: 0 0 0 10px;
      }
      .short-description__title {
        font-weight: 700;
        margin-bottom: 0px;
        font-size: 12px;
        display: block;
      }

      .short-description__content {
        line-height: 14px;
        color: #333;
        font-size: 11px;
        font-weight: 400;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

        @include breakpointMin(sm) {
        -webkit-line-clamp: 4;
        line-clamp: 4;
      }
      }
    }

    .announcement-card__actions {
      position: absolute;
      top: -48px;
      right: 0;
      bottom: 0;
      width: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #ddd;

      @include breakpointMin(sm) {
        top: -53px;
      }

      .announcement-card__button-container {
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #ccc;

        &:last-child {
          border-bottom: none;
        }

        .announcement-card__button {
          font-size: 14px;
          font-weight: 400;
          color: black;
          padding: 8px 16px;
          text-align: center;
          border: none;
          cursor: pointer;

          &--edit {
            background-color: transparent;
          }

          &--delete {
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>
